/** Hostname(s) for the operator portal only (no ERP chrome). */

const DEFAULT_OPS_HOSTS = ["usr.godo-erp.com"];

function configuredOpsHosts(): string[] {
  const raw = import.meta.env.VITE_OPS_PORTAL_HOSTS as string | undefined;
  const fromEnv = raw
    ?.split(",")
    .map((s) => s.trim().toLowerCase())
    .filter(Boolean);
  return fromEnv?.length ? fromEnv : DEFAULT_OPS_HOSTS;
}

/** True on usr.godo-erp.com (or ?ops=1 for local testing). */
export function isOpsPortalHost(): boolean {
  if (typeof window === "undefined") return false;
  const host = window.location.hostname.toLowerCase();
  if (configuredOpsHosts().includes(host)) return true;
  try {
    return new URLSearchParams(window.location.search).get("ops") === "1";
  } catch {
    return false;
  }
}

export function opsPortalPath(page: "sheet" | "platform"): string {
  if (isOpsPortalHost()) {
    return page === "sheet" ? "/sheet" : "/platform";
  }
  return page === "sheet" ? "/ops/sheet" : "/ops/platform";
}
